<template>
    <el-dialog
        :model-value="modelValue"
        :title="(isForm ? (teamId ? '修改班组' : '添加班组') : '查看') + dialogTitle"
        align-center
        @open="dialogOpen"
        @closed="handleCancel"
        width="640px"
    >
        <el-form
            :model="formData"
            :rules="isForm ? addInfoRules : {}"
            :validate-on-rule-change="false"
            ref="dialogForm"
            v-loading="loading"
            label-width="120px"
            :disabled="!isForm"
        >
            <el-form-item label="班组名称" prop="name">
                <el-input v-model="formData.name" placeholder="请输入班组名称" />
            </el-form-item>
            <el-form-item label="排序" prop="list_order">
                <el-input-number v-model="formData.list_order" class="mx-4" :min="0" :max="999999" controls-position="right" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">启用</el-radio>
                    <el-radio :value="0">禁用</el-radio>
                </el-radio-group>
                <!-- <div v-else>{{ formData.status ? '启用' : '禁用' }}</div> -->
            </el-form-item>

            <el-form-item label="班组人员：" prop="person_lists">
                <template #default>
                    <div class="manContainer">
                        <el-scrollbar>
                            <el-tag
                                v-for="(tag, index) in userTags"
                                :key="tag.id"
                                class="mx-1"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(index)"
                                style="margin: 2px"
                            >
                                {{ `${tag.name} (${tag.username})` }}
                            </el-tag>
                        </el-scrollbar>
                    </div>
                    <el-button
                        type="primary"
                        plain
                        class="button-new-tag ml-1"
                        size="small"
                        style="margin-left: 20px"
                        @click="addUser"
                    >
                        + 人员选择
                    </el-button>
                </template>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" :loading="submitLoading" @click="onConfirm(dialogForm)">确定</el-button>
        </template>
    </el-dialog>
    <man-dialog v-if="manDialogVisable" v-model="manDialogVisable" @getManList="getManList" :userTags="userTags"></man-dialog>
</template>

<script setup>
// 新增资料表单
import { defineEmits, defineProps, onMounted, reactive, ref } from 'vue'
import { ElInput, ElMessage } from 'element-plus'
import ManDialog from './man-dialog.vue'
import { addTeam, getTeamDetail, putTeam } from '@/api/teamManage/teamManage.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true
    },
    isAudit: {
        type: Boolean,
        default: false
    },
    isForm: {
        type: Boolean,
        required: true
    },
    teamId: {
        type: String,
        required: false
    }
})

// 表单的loading
const loading = ref(false)

const emits = defineEmits(['update:modelValue', 'updateForm'])
// 弹窗打开
const dialogOpen = async () => {
    formData.value = {
        name: '',
        list_order: 0,
        status: 1,
        person_lists: []
    }
    loading.value = true
    // 获取班组详情
    if (props.teamId) {
        const { name, person_information_lists, status, list_order } = await getTeamDetail(props.teamId)
        formData.value.name = name
        formData.value.list_order = list_order
        formData.value.status = status
        userTags.value = person_information_lists
        getManList(person_information_lists)
    }
    loading.value = false
}

// 弹窗关闭
// function dialogClosed() {
//     emits('update:modelValue', false)
//     console.log(dialogForm.value)
//     dialogForm.value && dialogForm.value.resetFields()
// }

// form表单数据
const formData = ref({
    name: '',
    list_order: 0,
    status: 1,
    person_lists: []
})

// 人员列表必填验证非中文验证
const validatePass = (rule, value, callback) => {
    console.log(value)
    if (!value.length) {
        callback(new Error('请至少添加一位班组人员'))
    } else {
        callback()
    }
}

// 申请表验证规则
const addInfoRules = reactive({
    name: [{ required: true, message: '请输入班组名称' }],
    list_order: [{ required: true, message: '请输入班组排序' }],
    status: [{ required: true, message: '请选择班组状态' }],
    person_lists: [{ required: true, validator: validatePass }]
})

const submitLoading = ref(false)
const dialogForm = ref(null)
function onConfirm(formEl) {
    if (!formEl) return
    formEl.validate(async (valid) => {
        if (valid) {
            submitLoading.value = true
            try {
                if (!props.teamId) {
                    // 添加
                    await addTeam(formData.value)
                } else {
                    // 修改
                    await putTeam({ id: props.teamId, data: formData.value })
                }
                submitLoading.value = false
                ElMessage.success('操作成功！')
                emits('updateForm')
                handleCancel()
            } catch (error) {
                submitLoading.value = false
            }
        } else {
            ElMessage.error('提交失败，请检查表单！')
        }
    })
}

// 班组名称
const dialogTitle = ref('')

// 点击弹窗取消按钮
function handleCancel() {
    userTags.value = []
    emits('update:modelValue', false)
}

// 添加班组人员
const userTags = ref([])
// 添加班组人员弹框
const manDialogVisable = ref(false)
const addUser = () => {
    manDialogVisable.value = true
}
// 删除人员
const handleClose = (index) => {
    userTags.value.splice(index, 1)
    formData.value.person_lists.splice(index, 1)
}

// 获取选择添加的人员
const getManList = (dataList) => {
    loading.value = true

    if (dataList.length) {
        userTags.value = [...dataList]
        formData.value.person_lists = dataList.map((item) => item.id)
    }
    loading.value = false
}

onMounted(() => {})
</script>

<style lang="scss" scoped>
.section-title {
    font-size: 16px;
    line-height: 32px;
    font-weight: bolder;
    margin-top: 10px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
}
.section-title::before {
    content: '';
    width: 4px;
    height: 15px;
    display: block;
    background-color: var(--theme-color);
    margin-right: 8px;
}

.el-form-item__content p {
    width: 200px;
}

.manContainer {
    width: 75%;
    height: 105px;
    border: 1px solid #dcdfe6;
    padding: 2px 5px;
    border-radius: 5px;
    // overflow: auto;
}
.icon:deep(el-icon) {
    padding-left: 10px;
}

.slider-demo-block {
    display: flex;
    align-items: center;
    width: 510px;
}
.slider-demo-block .el-slider {
    margin-top: 0;
    margin-left: 12px;
}
</style>
